/**
 * ? @description : Frequently Asked Questions Component
 */

// Dependencies
import React from "react";
import { Accordion } from "react-bootstrap";

function FAQ() {
  return (
    <div class="container pt-5">
      <h1>FAQ</h1>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>What is callout? how to create it?</Accordion.Header>
          <Accordion.Body>
          The callout is used to send invites to volunteers to become LTE teachers. We can send callouts by 2 ways <br />
          way 1 - send invitation through mail. <br/>
          way 2 - copy the invite from the callout popup and paste it any third-party communication app ex:    Whatsapp..etc <br />
          To create callout, go to mainscreen → callout → click callout via mail button 
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="1">
          <Accordion.Header>
            How to create batch?
          </Accordion.Header>
          <Accordion.Body>
            Go to main screen → TEACHER TRAINING →TRaining Batch → click on create batch button <br />
            You must include at least one teacher to create a batch
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="2">
          <Accordion.Header>
            How many students and teachers can a batch  have?
          </Accordion.Header>
          <Accordion.Body>
            We can add multiple students to single batch, but there is only 1 teacher in a batch.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="3">
          <Accordion.Header>
            How many students can a teacher have?
          </Accordion.Header>
          <Accordion.Body>
            A teacher can have multiple students.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="4">
          <Accordion.Header>
            What is grouping?
          </Accordion.Header>
          <Accordion.Body>
            Grouping is creating a group/ batch for teachers and students.Grouping and Batching are same .we can use both names.We perform grouping/batching for teachers. For students while mapping, grouping/mapping can be done internally.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="5">
          <Accordion.Header>
            What is mapping? how to perform mapping?
          </Accordion.Header>
          <Accordion.Body>
            Mapping is a process to assign students to a teacher ,we perform this process based on common languages of students and teacher. <br />
            To perform mapping, Go to mainscreen → TEACHER STUDENT ALLOCATIONS → Unmapped → select teacher and students to map, then click on "Create Mapping" button
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="6">
          <Accordion.Header>
            What is a comment? how to create a comment?
          </Accordion.Header>
          <Accordion.Body>
            A comment is nothing but creating notes about teacher and student under different scenarios.<br />
            Comments for teachers → we add comments for teacher in the process of converting voulnteers to teacher. <br />
            Comments for students → we add comments for student to make note of it for further proceedings.
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="7">
          <Accordion.Header>
            How to unmap a student?
          </Accordion.Header>
          <Accordion.Body>
            To unmap a student, Go to mainscreen → TEACHER STUDENT ALLOCATIONS → Mapped → click on action button → click "Unmap".
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}

export default FAQ;
